<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="md"
      class="alert-modal"
      hide-header-close
      footer-class="pt-0 border-0"
    >
      <template #modal-header>
        <div class="modal-title">โอน ({{ product.productName }})</div>
      </template>
      <div class="d-block">
        <InputSelect
          placeholder="คลังต้นทาง"
          :validateText="`กรุณาเลือกคลัง`"
          title="คลังต้นทาง"
          v-model="form.inventory_from"
          :isValidate="$v.form.inventory_from.$error"
          :v="$v.form.inventory_from"
          @onDataChange="handleInventoryFrom($event, 0)"
          valueField="id"
          textField="name"
          class="mt-2"
          :options="listStock"
        >
          <template v-slot:option-first>
            <b-form-select-option :value="0" disabled
              >กรุณาเลือกคลังต้นทาง</b-form-select-option
            >
          </template>
        </InputSelect>
        <InputText
          v-if="!form.is_serial"
          v-model="form.amount"
          textFloat="โอนจำนวน"
          placeholder="จำนวน"
          type="number"
          @input="handleAmoutInput"
          name="transfer_amount"
          className="mb-2"
          isRequired
          :textDesc="`จำนวนปัจจุบัน : ${form.stock_from}`"
          :isValidate="$v.form.amount.$error"
          :v="$v.form.amount"
        />
        <div v-else>
          <b-row>
            <b-col cols="12">
              <label class="main-label">Serial</label>
            </b-col>
          </b-row>
          <div class="px-3 maxheight-290px">
            <b-row class="mb-3">
              <b-col cols="12">
                <b-input-group class="justify-content-end">
                  <b-form-input
                    textFloat=""
                    :disabled="!form.inventory_from"
                    placeholder="Search Serial"
                    type="text"
                    v-model="searchSerial"
                    @input="handlesearchSerial"
                  >
                  </b-form-input>
                  <b-input-group-append is-text class="mr-2 h-35px">
                    <b-iconstack
                      font-scale="2"
                      type="submit"
                      @click="handlesearchSerial"
                      :disabled="!form.inventory_from"
                    >
                      <b-icon
                        stacked
                        icon="search"
                        scale="0.5"
                        variant="grey"
                      ></b-icon>
                    </b-iconstack>
                  </b-input-group-append> </b-input-group
              ></b-col>
            </b-row>
            <b-row
              class="mt-2"
              v-for="(item, index) in filteredSerial"
              :key="`serial-move-${index}`"
            >
              <b-col cols="1" class=""
                ><div class="d-flex justify-content-center mt-2">
                  #{{ index + 1 }}
                </div>
              </b-col>
              <b-col cols="10" class="p-0">
                <InputText
                  textFloat=""
                  :disabled="true"
                  placeholder="Serial"
                  type="text"
                  v-model="item.serial"
                />
              </b-col>
              <b-col cols="1" class="">
                <b-form-checkbox
                  class="pl-3 mt-2"
                  name=""
                  :disabled="
                    !form.inventory_from ||
                    mountingList.find(
                      (x) => x.serial === item.serial && !item.isMother
                    )
                      ? true
                      : false
                  "
                  :value="item.serial"
                  :checked="form.serial"
                  :unchecked-value="false"
                  @change="inputSerial(item.serial, 1)"
                >
                </b-form-checkbox>
              </b-col>
              <b-col cols="12" class="mb-2" v-if="item.isMother">
                <b-row class="mx-2">
                  <b-col
                    cols="12"
                    v-for="(m, index_m) in item.mountingList.filter(
                      (x) => !x.isDupe
                    )"
                    :key="`mounting+${index_m}`"
                    class="f-12px mr-1 text-gray d-flex justify-content-between border-bottom border-left border-right"
                  >
                    <div class="ml-2 my-2">Serial: {{ m.serial }}</div>

                    <div class="mr-2 my-2">Stock : {{ m.stock_type_name }}</div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <div v-if="$v.form.serial.$error" class="text-error">
              Please Select Serial
            </div>
          </div>
        </div>
        <InputSelect
          title="สาขาปลายทาง"
          isRequired
          :validateText="`กรุณาเลือกสาขา`"
          :options="branchList"
          v-model="form.to_branch_id"
          @onDataChange="onDataChange"
          :isValidate="$v.form.to_branch_id.$error"
          :v="$v.form.to_branch_id"
          textField="branch_name"
          valueField="branch_id"
          className="mb-0 mt-2"
        >
          <template v-slot:option-first>
            <b-form-select-option value="" disabled
              >กรุณาเลือกสาขาปลายทาง</b-form-select-option
            >
          </template></InputSelect
        >

        <InputSelect
          placeholder="คลังปลายทาง"
          :validateText="`กรุณาเลือกคลัง`"
          title="คลังปลายทาง"
          v-model="form.stock_type_id"
          :isValidate="$v.form.stock_type_id.$error"
          :v="$v.form.stock_type_id"
          @onDataChange="handleInventoryFrom($event, 1)"
          valueField="id"
          :disabled="!form.inventory_from || !form.to_branch_id"
          textField="name"
          class="mt-2"
          :options="listStockTo"
        >
          <template v-slot:option-first>
            <b-form-select-option :value="0" disabled
              >กรุณาเลือกคลังปลายทาง</b-form-select-option
            >
          </template>
        </InputSelect>

        <div
          class="border-top panel-display-count mt-3"
          v-if="form.stock_type_id"
        >
          <div class="d-flex justify-content-between mb-2">
            <p class="label">จำนวนสุทธิ (สาขาปลายทาง)</p>
            <p>
              จำนวนปัจจุบัน :
              {{ form.stock }}
            </p>
          </div>
          <p>
            {{ form.available_to }}
          </p>
        </div>
      </div>
      <template #modal-footer="{ hide }">
        <div class="d-flex justify-content-between w-100 my-0">
          <b-button
            variant="close"
            class="btn-modal btn-hover w-50 mr-1"
            @click="hide('forget')"
            :disabled="isLoading"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover w-50 ml-1"
            @click="save"
            :disabled="isLoading"
          >
            ยืนยัน
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import { required, minValue, requiredIf } from "vuelidate/lib/validators";
const minAmount = (value, form) => {
  return (!form.is_serial && value > 0) || form.is_serial;
};
export default {
  components: {
    InputText,
    InputSelect,
  },
  props: {
    branchId: {
      required: true,
      type: [String, Number],
    },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      form: {
        amount: "",
        available: 0,
        avilable: 0,
        note: "",
        currentStock: 0,
        stock: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: 0,
        available_to: 0,
        inventory_from: 0,
        product_id: 0,
        stock_from: 0,
        inventory_id: 0,
        to_branch_id: "",
      },
      branchList: [],
      product: {},
      fromModal: "",
      item: {},
      listStock: [],
      listStockTo: [],
      listSerial: [],
      filteredSerial: [],
      searchSerial: "",
      mountingList: [],
    };
  },
  validations() {
    return {
      form: {
        amount: {
          required: requiredIf(function () {
            return !this.form.is_serial;
          }),
          minAmount() {
            return minAmount(this.form.amount, this.form);
          },
        },
        stock_type_id: {
          minValue: minValue(1),
        },
        serial: {
          required: requiredIf(function () {
            return this.form.is_serial;
          }),
        },
        inventory_from: {
          minValue: minValue(1),
        },
        to_branch_id: {
          minValue: required,
        },
      },
    };
  },
  computed: {
    branchToSelect() {
      let branch = this.branchList.filter(
        (item) => item.branch_id == this.form.to_branch_id
      );
      return branch.length ? branch[0] : null;
    },
  },
  methods: {
    async show(item, fromModal = "") {
      this.form = {
        amount: "",
        available: 0,
        avilable: 0,
        note: "",
        currentStock: 0,
        stock: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: 0,
        available_to: 0,
        inventory_from: 0,
        product_id: 0,
        stock_from: 0,
        inventory_id: 0,
        to_branch_id: "",
      };
      this.filteredSerial = [];
      this.listStock = [];
      this.listStockTo = [];
      this.listSerial = [];
      this.filteredSerial = [];
      this.searchSerial = "";
      this.bracnchStock = "";
      this.form.is_serial = item.is_serial;
      this.product.id = item.product_id;
      this.product.productName = item.name;
      this.product.inventoryId = item.id;
      this.product.currentStock = item.stock;
      this.product.branchId = item.branch_id;
      this.form.product_id = item.product_id;
      this.$nextTick(() => {
        this.$v.$reset();
      });

      await this.getStockList(this.branchId, true);
      await this.getOtherBranchInventory(this.product.id);

      this.showModal = true;
    },
    async getSerialFromStock() {
      if (this.form.is_serial) {
        const responseSerial = await this.axios.get(
          `${this.$baseUrl}/Inventory/GetInventorySerial/${this.branchId}/${this.form.product_id}/${this.form.inventory_from}`
        );
        this.listSerial = responseSerial.detail;
        this.filteredSerial = responseSerial.detail;
      }
    },
    async getStockList(branchId, isFrom) {
      const res = await this.axios.get(
        `${this.$baseUrl}/Inventory/GetActiveStockType/${branchId}/${this.form.product_id}`
      );

      if (res.result) {
        if (isFrom) {
          this.listStock = res.detail.map((x) => ({
            ...x,
            name: x.name + " (" + x.stock + ")",
            disabled: false,
          }));
        } else {
          this.listStockTo = res.detail.map((x) => ({
            ...x,
            name: x.name + " (" + x.stock + ")",
            disabled: false,
          }));
        }
      }
    },
    hide() {
      this.filteredSerial = [];
      this.mountingList = [];
      this.showModal = false;
    },
    handleMaxTransfer(val) {
      return parseInt(val) <= parseInt(this.product.stock);
    },
    async save() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      let body = {
        edit_type: 9,
        ...this.form,
        amount: this.form.amount || 0,
        branch_id: this.branchId,
      };
      await this.$store.dispatch("setMainLoading", true);
      if (this.mountingList.length) {
        this.mountingList = this.mountingList.map((x) => ({
          inventory_id: this.form.inventory_id,
          branch_id: this.branchId,
          product_id: x.product_id,
          stock: this.form.stock,
          inventory_from: x.stock_type_id,
          stock_from: this.form.stock_from,
          amount: this.form.amount || 0,
          edit_type: 9,
          note: this.form.note,
          available: this.form.available,
          is_serial: 1,
          serial: [x.serial],
          stock_type_id: this.form.stock_type_id,
          available_to: this.form.available_to,
          to_branch_id: this.form.to_branch_id,
        }));
        const existingSerials = this.mountingList.flatMap(
          (item) => item.serial
        );
        let other = this.form.serial
          .filter((y) => !existingSerials.includes(y))
          .map((x) => ({
            inventory_id: this.form.inventory_id,
            branch_id: this.branchId,
            product_id: this.filteredSerial.find((s) => s.serial == x)
              .product_id,
            stock: this.form.stock,
            inventory_from: this.form.inventory_from,
            stock_from: this.form.stock_from,
            amount: this.form.amount || 0,
            edit_type: 9,
            note: this.form.note,
            available: this.form.available,
            is_serial: 1,
            serial: [x],
            stock_type_id: this.form.stock_type_id,
            available_to: this.form.available_to,
            to_branch_id: this.form.to_branch_id,
          }));

        this.mountingList.push(...other);

        const response = await this.axios.post(
          `${this.$baseUrl}/inventory/UpdateInventory/mounting`,

          this.mountingList
        );

        if (response.result) {
          this.successAlert();
          this.hide();
        } else this.errorAlert(response.message);
        this.$emit("reloadDataTable");
        await this.$store.dispatch("setMainLoading", false);
        return;
      }

      await this.axios
        .post(`${this.$baseUrl}/Inventory/UpdateInventory`, {
          ...body,
          serial: this.form.serial,
        })
        .then(async (data) => {
          await this.$store.dispatch("setMainLoading", false);
          if (data.result == 1) {
            this.successAlert();
            this.$emit("reloadDataTable");
            this.hide();
          } else {
            this.errorAlert("Duplicate serial number");
          }
        });
      this.isLoading = false;
    },
    async onDataChange(val) {
      this.form.to_branch_id = val;
      await this.getStockList(val, false);
    },
    async getOtherBranchInventory(productId) {
      await this.$store.dispatch("setMainLoading", true);
      let filtered = [];
      await this.axios
        .get(`${this.$baseUrl}/Inventory/GetBranchs/${productId}`)
        .then(async (data) => {
          if (data.result == 1) {
            filtered = data.detail.filter(
              (item) => item.branch_id != this.branchId
            );
          }
          await this.$store.dispatch("setMainLoading", false);
          this.branchList = filtered;
        });
    },

    async handleInventoryFrom(input, isToStock) {
      if (!isToStock) {
        this.form.inventory_from = input;
        this.listStockTo = this.listStock.map((x) => ({
          ...x,
          disabled: false,
        }));
        this.form.available_to = this.form.available_to - this.form.amount;
        this.form.amount = "";
        this.form.stock_from = this.listStock.find((x) => x.id == input).stock;
        this.form.available = this.listStock.find((x) => x.id == input).stock;

        await this.getSerialFromStock();
      } else {
        this.form.stock_type_id = input;
        this.form.stock = this.listStockTo.find((x) => x.id == input).stock;
        if (this.form.is_serial) {
          this.form.available_to = this.form.serial.length + this.form.stock;
        } else {
          this.form.available_to = this.form.amount
            ? this.form.amount + this.form.stock
            : this.form.stock;
        }

        this.form.inventory_id = this.listStockTo.find(
          (x) => x.id == input
        ).inventory_id;
      }
    },
    async inputSerial(serial, isMove) {
      const item = this.filteredSerial.find((x) => x.serial === serial);
      if (this.form.serial.includes(serial)) {
        this.form.serial = this.form.serial.filter((item) => item !== serial);
        this.form.available += 1;
        if (item.isMother) {
          const mountedInFiltered = item.mountingList.filter((child) =>
            this.filteredSerial.some((f) => f.serial === child.serial)
          );

          const mountedCount = mountedInFiltered.length;

          if (isMove && this.form.stock_type_id) {
            const filteredStock = item.mountingList.length + 1 || 1;
            this.form.available_to -= filteredStock;
          }

          this.form.available += mountedCount;

          this.form.serial = this.form.serial.filter(
            (s) =>
              s !== item.serial &&
              !item.mountingList.some((m) => m.serial === s)
          );

          this.mountingList = this.mountingList.filter(
            (m) => !item.mountingList.some((child) => child.serial === m.serial)
          );

          item.mountingList = [];
          item.isMother = false;

          return;
        }
        if (isMove && this.form.stock_type_id) {
          this.form.available_to -= 1;
        }
      } else {
        if (!this.form.stock_type_id) {
          this.warningAlert("กรุณาเลือกสาขาปลายทางและคลังปลายทาง!");
          this.form.serial.push(serial);
          this.form.serial = this.form.serial.filter((s) => s !== serial); //ต้องทำแบบนี้ไม่อย่างนั้นตัว Checkbox จะถูกติ๊ก
          return;
        }
        this.form.serial.push(serial);
        if (serial) {
          const res = await this.axios(
            `${this.$baseUrl}/product/product_serial_mounting/${this.branchId}/${this.form.product_id}/${serial}`
          );

          const mountingList = res.detail;

          if (mountingList.length) {
            const serialsToAdd = mountingList.map((x) => x.serial);
            this.form.serial.push(...serialsToAdd);

            item.mountingList = mountingList.map((x) => ({
              ...x,
              isDupe: this.filteredSerial.some((y) => y.serial === x.serial),
            }));

            this.mountingList.push(...mountingList);

            const mother = this.filteredSerial.find((x) => x.serial === serial);
            if (mother) mother.isMother = true;
            item.isMother = true;

            const mountedInFiltered = item.mountingList.filter((child) =>
              this.filteredSerial.some((f) => f.serial === child.serial)
            );

            const mountedCount = mountedInFiltered.length;

            this.form.available -= 1 + mountedCount;

            if (this.form.stock_type_id) {
              const filteredStock = item.mountingList.length + 1 || 1;
              this.form.available_to += filteredStock;
            }

            return;
          }
        }

        this.form.available -= 1;
        if (isMove && this.form.stock_type_id) {
          this.form.available_to += 1;
        }
      }
    },
    handlesearchSerial(val) {
      this.filteredSerial = this.listSerial.filter((x) =>
        x.serial.toLowerCase().includes(val.toLowerCase())
      );
    },
    handleAmoutInput(value, $event) {
      if (this.form.stock_from < value) {
        return this.$nextTick(() => {
          $event.preventDefault();

          this.form.amount = Number(this.form.stock_from);
          this.form.available = 0;
          this.form.available_to = this.form.stock + this.form.amount;
          return ($event.target.value = Number(this.form.stock_from));
        });
      } else {
        this.form.available_to = this.form.amount + this.form.stock;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
.panel-display-count {
  padding-top: 10px;
  p.label {
    color: #333 !important;
    font-weight: bold !important;
  }
  p {
    color: #999 !important;
    font-size: 14px !important;
  }
}

.h-35px {
  height: 35px;
}

.maxheight-290px {
  max-height: 290px !important;
  overflow: auto;
}
</style>
